import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: ":nodeId",
  component: withAsyncRouteLoading(() => {
    return Promise.all([
      import(/* webpackChunkName: "content-skills" */ "./components"),
    ]).then(([importedModule0]) => {
      return importedModule0.default;
    });
  }),
  childRoutes: [],
});
